module.exports = __webpack_public_path__ + "img/light_m_bg.26fd282e.png";